module.exports = __webpack_public_path__ + "static/media/game.c7f135f8.svg";